<template>
  <div class="cp-content">
    <div class="close" @click="handleClose"></div>
    <div class="content">
      <div class="content-header"></div>
      <div class="content-center">
        <div class="title"></div>
        <div class="text">
          1，每个游戏的礼包内容均不同，请在秒杀成功物品时，提供对应游戏的信息，礼包将在游戏内直接发给您提供的游戏角色
          <br>
          2，礼包内容划分如下：
          <div v-for="(item, index) in prizeList" :key="index">
            <div class="name">{{item.title}}</div>
            <div class="prize">{{item.content}}</div>
          </div>
        </div>
      </div>
      <div class="content-footer"></div>
    </div>
  </div>
</template>

<script>
import store from '~/store/index';
import * as types from '~/store/mutation-type';

export default {
  name: 'Content',
  data() {
    return {
      prizeList: [
        {title: '周年庆梦想坐骑包', content: '征途（国风坐骑*1），征途2（熊猫头像卡*15天），绿色征途（熊猫宝宝*7天），征途怀旧（宠物外观-仙鹿*30天），征途手机版（经典图鉴碎片*25），征途2手游（海音光环*7天），绿征手游（勇猛战熊*7天），原始征途（坐骑装备宝箱*5）'},
        {title: '周年庆为梦奔跑包', content: '征途（告白气球坐骑*1），征途2（彩蛋-美猴王·孙悟空*1），绿色征途（要啥自行车*7天），征途怀旧（坐骑外观-香车宝马*30天），征途手机版（绿色卡牌车夫*1），征途2手游（玉兔年糕脸饰*15天），绿征手游（培元丹*30+银子1锭*88），原始征途（押镖令·黄*2+培训令牌·黄*2+藏宝图*12）'},
        {title: '周年庆与君共饮包', content: '征途（周年庆红包点数*1888），征途2（酒·绿色*30），绿色征途（天灵豹*7天），征途怀旧（额外包裹修复石*2），征途手机版（经典绿色随宠礼包*1），征途2手游（美酒品尝包*绿*3），绿征手游（换货金币*2+投保令*1），原始征途（二等魂魄石*1+升级宝石*5）'},
        {title: '周年庆书写青史包', content: '征途（气泡-热血征途*1），征途2（“诗书乐画·仙”神将自选*1），绿色征途（火灵豹*7天），征途怀旧（999鲜花礼盒*2）	，征途手机版（宾果礼花*99），征途2手游（玉灵猫妖*7天），绿征手游（武神经验*30000+银子30锭），原始征途（三等材料*5+中级淬炼石*5）'},
        {title: '周年庆追梦能量包', content: '征途（周年庆红包点数*2888），征途2（经验果实·绿色*40），绿色征途（金灵豹*7天），征途怀旧（时装-万紫千红*7天），征途手机版（孙尚香随宠*1），征途2手游（鲜果品尝包·绿*4），绿征手游（高级藏宝图*3+刮刮乐奖券*5），原始征途（押镖令·黄*1+培训令牌·黄*1+藏宝图*1）'},
        {title: '周年庆对酒当歌礼包', content: '征途（桃花醉·橙*16+逐风美酿·橙*16），征途2（图鉴-冻海冰晶*1），绿色征途（星月青鸾*永久），征途怀旧（宠物外观-财迷心窍*365天），征途手机版（紫色卡牌赵子龙*1），征途2手游（美酒畅享包·绿*99），绿征手游（紫色武神卡-荀彧*1+银子88锭），原始征途（四等材料*10+中级淬炼石*20+升级宝石*50）'},
        {title: '周年庆马上发财包', content: '征途（时装-岁月静好*1），征途2（马上有钱*15天），绿色征途（恭喜发财*30天），征途怀旧（坐骑外观-月兔*30天），征途手机版（极北孤狼坐骑*1），征途2手游（逆天红莲时装*15天），绿征手游（周年庆红包*工资666两），原始征途（天香蜜露*2+绑银5锭）'}
      ]
    }
  },
  mounted() {

  },
  methods: {
    handleClose(e) {
      store.commit(types.HIDE_MODAL);
    }
  }
}
</script>
<style rel="stylesheet/stylus" lang="stylus" scoped>
  .cp-content
    width 100%
    height 100%
    display flex
    flex-direction column
    justify-content center
    align-items center
    .close
      width 0.47rem
      height 0.47rem
      background-image url('./images/close.png')
      background-size 100% 100%
      margin-bottom 0.12rem
      cursor: pointer
      transition transform 0.6s ease-in-out
      &:hover
        transform: rotateZ(360deg);
    .content
      width 5.18rem
      &-header
        width 5.18rem
        height 0.37rem
        background-image url('./images/modal-header.png')
        background-size 100% 100%
      &-center
        width 5.18rem
        padding 0 0.17rem
        background-image url('./images/center.png')
        background-size 100% 100%
        background-repeat repeat-y
        line-height 0.34rem
        font-size 0.18rem
        color #622606
        margin-top -1px
        .title
          width 3.28rem
          height 0.45rem
          margin-left 0.78rem
          background-image url('./images/header.png')
          background-size 100% 100%
        .text
          margin-top 0.18rem
          padding: 0 0.2rem
          overflow-y auto
          min-height 3rem
          max-height 7rem
        .name
          margin-top 0.4rem
          color #bd100c
          font-size 0.22rem
          font-weight bold
          line-height 1
          text-align center
          margin-bottom 0.08rem
      &-footer
        margin-top -1px
        width 5.18rem
        height 0.26rem
        background-image url('./images/modal-footer.png')
        background-size 100% 100%
</style>
